<template>
   <span>
      <span v-if="!type || type === 'candy'" 
         :class="candyClass" 
         @click="clicked(id)" 
         @mousedown.prevent="preventMouseDown"> 
         {{ label }} 
      </span>
      <span v-if="type === 'page'" 
         :class="pageClass" 
         @click="clicked(id)" 
         @mousedown.prevent="preventMouseDown"> 
         {{ label }}
      </span>      
   </span>
</template>

<script>
// Should probably convert this component to use scoped-slots in the future
export default {
   name: 'ActionButton',
   props: {
      label: {
         type: String,
         required: true
      },
      id: {
         type: String,
         required: true
      },
      active: {
         type: Boolean,
         required: true
      },
      type: {
         type: String,
         required: false
      }
   },
   data: function() { 
      return {}
   },
   methods: {
      clicked: function (itemId) {
         this.$emit('clicked', itemId);
      },
      preventMouseDown: (e) => {}
   },
   computed:  {
      candyClass: function() {
         return {
            'candy-button': true,
            'candy-active': this.active,
            'candy-inactive': !this.active
         }
      },
      pageClass: function() {
         return {
            'page-button': true,
            'page-active': this.active,
            'page-inactive': !this.active
         }
      }
   }
}
</script>

<style scoped>
/* Budget Forecast Actual */
.candy-button {
   font-weight: bold;
   border: solid 1px;
   border-radius: 4px;
   padding: 0.2em 0.4em;
   border-color: black;
   cursor: pointer;
}

.candy-active {
   background: black;
   color: white;
}

.candy-inactive {
   background: none;
   color: black;
}

.page-button {
   padding: 0.2em 0.4em;
   cursor: pointer;
}

.page-active {
   color: black;
   font-weight: bold;
}

.page-inactive {
   color: #777777; /* COLOR GREY OUT  */
}
</style>



// WEBPACK FOOTER //
// src/components/common/form/TabButton.vue